<template>
  <v-app class="platform-font">
    <main-app-bar />
    <v-main :full-screen="$root.fullScreenView">
      <router-view />
    </v-main>
    <main-footer-bar />
  </v-app>
</template>

<script>
import MainAppBar from "@/components/MainAppBar";
import MainFooterBar from "@/components/MainFooterBar";
import constant from "../const";

export default {
  components: {
    MainAppBar,
    MainFooterBar
  },
  data: () => ({
    username: null
  }),

  created() {},

  methods: {}
};
</script>